export const UPDATE_FORM_DATA = "UPDATE_FORM_DATA";
export const UPDATE_FORM_VALUE = "UPDATE_FORM_VALUE";
export const UPDATE_FIELD_VALUE = "UPDATE_FIELD_VALUE";
export const UPDATE_TABLE_FIELD_VALUE = "UPDATE_TABLE_FIELD_VALUE";
export const UPDATE_TALLY_FIELD_VALUE = "UPDATE_TALLY_FIELD_VALUE";
export const RESET_TOTAL_FORM_DATA = "RESET_TOTAL_FORM_DATA";